import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import * as globalVariables from "../../commonVariableList/addInvoice";
import { ToasterService } from 'angular2-toaster';
import { LocalStorageService } from '../../shared/services/storage/local-storage.service';
import { WebServiceService } from '../../shared/services/web-service.service';
@Component({
  selector: 'app-generic-accordion-approvals',
  templateUrl: './generic-accordion-approvals.component.html',
  styleUrls: ['./generic-accordion-approvals.component.scss']
})
export class GenericAccordionApprovalsComponent implements OnInit {
  @Input() approvalDetails: any;
  isProcessing:boolean=true;

  commonVariableList: any = { "columnList": [], "items": [], "approvals": [], "isProgressBar": true, }
  @Output()
  sendAction = new EventEmitter()
  companyThemeBlockColor: any = "";
  CompanyThemetextColor: any = "";
  constructor(private toasterService: ToasterService,public _localStorageService: LocalStorageService, public webService : WebServiceService) { }
  company_setup: any = {};
  ngOnInit() {
    if (this.approvalDetails.id) {
      this.commonVariableList.items = [];
      this.commonVariableList.approvals = [];
     let approval;
      this.commonVariableList.approvals = this.approvalDetails.data.approvals ? this.approvalDetails.data.approvals : []
        for(let i=0; i<this.commonVariableList.approvals.length; i++){
          this.commonVariableList.approvals[i].is_approver_updated = this.commonVariableList.approvals[i].is_approver_updated ? this.commonVariableList.approvals[i].is_approver_updated : '0';
          if(this.commonVariableList.approvals[i].approval_status == '2') {
            approval = i+1;
            break;
          }
        }
     
        if(this.approvalDetails.id == "prreport"){
          if(this.approvalDetails.data.final_approval_status=='0' || this.approvalDetails.data.has_multi_approval == '1') {
            let pendingAppLevel = '';
            let pendingAppType = '';
            for(let i=0; i<this.commonVariableList.approvals.length; i++){
              if(this.commonVariableList.approvals[i].final_approval_status=='0') {
                pendingAppLevel = this.commonVariableList.approvals[i].employee_level;
                pendingAppType = this.commonVariableList.approvals[i].approval_type;
                break;
              }
            }
  
            let pendingAppLevelInt = this.webService.convertNaN(pendingAppLevel)
  
            if(pendingAppType!='' && pendingAppLevel!='') {
              if(pendingAppType=='Anyone') {
                for(let i=0; i<this.commonVariableList.approvals.length; i++){
                  let tmpPendingAppLevelInt = this.webService.convertNaN(this.commonVariableList.approvals[i].employee_level)
                  if(pendingAppLevelInt > tmpPendingAppLevelInt) {
                    this.commonVariableList.approvals[i].approval_status = this.commonVariableList.approvals[i].approval_status=='0' && this.commonVariableList.approvals[i].approval_status=='0' ? '3' : this.commonVariableList.approvals[i].approval_status;
                  }
                }
              } else if(pendingAppType=='Multiple') {
                
                let pendingAppLevelInt = this.webService.convertNaN(pendingAppLevel)
                for(let i=0; i<this.commonVariableList.approvals.length; i++){
                  let tmpPendingAppLevelInt = this.webService.convertNaN(this.commonVariableList.approvals[i].employee_level)
                  if(pendingAppLevelInt > tmpPendingAppLevelInt) {
                    this.commonVariableList.approvals[i].approval_status = this.commonVariableList.approvals[i].approval_status=='0' ? '3' : this.commonVariableList.approvals[i].approval_status;
                  }
                }
              } else {
                for(let i=0; i<this.commonVariableList.approvals.length; i++){
                  let tmpPendingAppLevelInt = this.webService.convertNaN(this.commonVariableList.approvals[i].employee_level)
                  if(pendingAppLevelInt > tmpPendingAppLevelInt) {
                    this.commonVariableList.approvals[i].approval_status = this.commonVariableList.approvals[i].approval_status=='0' && this.commonVariableList.approvals[i].approval_status=='0' ? '3' : this.commonVariableList.approvals[i].approval_status;
                  }
                }
              }
            }
          } else {
            for(let j=approval; j<this.commonVariableList.approvals.length; j++){
              this.commonVariableList.approvals[j].approval_status = '3';
            }
          }
        }else{
          for(let j=approval; j<this.commonVariableList.approvals.length; j++){
            this.commonVariableList.approvals[j].approval_status = '3';
          }
        }
      


      this.isProcessing=false;

      setTimeout(() => {
        this.commonVariableList.isProgressBar = false;
      }, 2000);
    }
    this.companyThemeBlockColor = this._localStorageService.getCompanyTheme() ? this._localStorageService.getCompanyTheme() : "#035168";
    this.CompanyThemetextColor = this._localStorageService.getCompanyThemeColor() ? this._localStorageService.getCompanyThemeColor() : "#FFFFFF";
    this.GetCompanySetUpData();

  }

 
  GetCompanySetUpData() {
    let req:any={
      "company_id": this._localStorageService.getEmpCompanyId() ? this._localStorageService.getEmpCompanyId() : "0",
      variable_list:["in_invoice_date_format"],
    }
    this.company_setup={}
    this.webService.commonPostMethod("Update_company_meta/ajax_getall_bycompany", req).subscribe(
      data => {
        if (data.status) {
          this.company_setup={}
          this.company_setup=data.response ? data.response : {}
          this.company_setup.in_invoice_date_format = this.company_setup.in_invoice_date_format ? this.company_setup.in_invoice_date_format : "dd-mm-yyyy";
          
        }
      },
      error => {

      }
    )
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src1197828953/src/src/app/generic-ui-components/generic-accordion-approvals/generic-accordion-approvals.component.ts